module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('b', [_vm._v("An Garda Síochána:")]), _vm._v(" the police service of the Republic of Ireland.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Garda, or gardaí in the plural.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Commonly referred to as "), _c('i', [_vm._v("the guards ")]), _vm._v("or "), _c('i', [_vm._v("the gardaí.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Direct translation: “the Guardian of the Peace.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31bce514","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 78
// module chunks = 0